// extracted by css-extract-rspack-plugin
export default {"container":"LinkItem-module__container__xEwdA","leadingIcon":"LinkItem-module__leadingIcon__ciS4F","linkIndicator":"LinkItem-module__linkIndicator__DMdP9"};